import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import MainQuiz from "../../components/quiz/MainQuiz";
import { fetchQuizById } from "../../redux/actions/quizzesActionCreators";

const BaseQuiz = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.quizzes.selected);
  const isAuth = useSelector((state) => state.user.isAuth);
  const isAllowed = useSelector((state) => state.quizzes.isAllowed);

  const params = useParams();

  const orgaId = localStorage.getItem("orgaId");
  const storedUser = localStorage.getItem("user");
  const accountType = JSON.parse(storedUser)?.account_type;

  useEffect(() => {
    if (accountType === "enterprise") {
      dispatch(fetchQuizById(isAuth, params.quizId, orgaId, accountType));
    } else {
      dispatch(fetchQuizById(isAuth, params.quizId));
    }
  }, [dispatch, params.quizId, accountType, orgaId]);

  return (
    <>
      {data ? (
        <MainQuiz
          data={data}
          initialPayload={{}}
          initialThreshold={{}}
          isAllowed={isAllowed}
        />
      ) : null}
    </>
  );
};

export default BaseQuiz;
